/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_OnInputs */



/**
* | output |
* | --- |
* | "Microphone is on" |
*
* @param {Practice_Session_Mic_OnInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_on = /** @type {((inputs?: Practice_Session_Mic_OnInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_OnInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microfoon staat aan")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Micro activé")
	return /** @type {LocalizedString} */ ("Microphone is on")
});